import { Title } from "@justhome/react-ui";
import {
  ComponentBlocksButton,
  ComponentBlocksCardButton,
  Maybe,
} from "@lib/generated/graphql";
import clsx from "clsx";
import { FC, HTMLAttributes } from "react";
import Button from "../../blocks/Button";
import CardButton from "../../blocks/CardButton";

type CTAButtonContainerProps = {
  button?: Maybe<ComponentBlocksButton>;
  cardButton?: Maybe<ComponentBlocksCardButton>;
};

const CTAActionContainer: FC<{
  CTA: CTAButtonContainerProps;
  className?: string;
}> = ({ CTA, className }) => {
  if (CTA.button) {
    return (
      <Button
        {...CTA.button}
        className={clsx(
          "w-full justify-center m:justify-start m:w-fit mt-m",
          className,
        )}
      />
    );
  }
  if (CTA.cardButton) {
    return (
      <CardButton
        className={clsx("mt-m", className)}
        {...CTA.cardButton}
      />
    );
  }
  return null;
};

const CTATitle = ({
  children,
  className,
}: {
  children?: Maybe<string>;
  className?: string;
}) => {
  if (!children) {
    return null;
  }
  return <Title className={className}>{children}</Title>;
};

const CTASubTitle: FC<
  HTMLAttributes<HTMLParagraphElement> & { inverted?: boolean }
> = ({ children, className, inverted, ...props }) => {
  if (!children) {
    return null;
  }
  return (
    <p
      className={clsx(
        "text-body-1 mt-3s whitespace-pre-line ",
        className,
        {
          "text-neutral-0": inverted,
          "text-neutral-575": !inverted,
        },
      )}
      {...props}
    >
      {children}
    </p>
  );
};

const CTABody: FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  ...props
}) => {
  return <div {...props}>{children}</div>;
};

export default Object.assign(CTABody, {
  Title: CTATitle,
  SubTitle: CTASubTitle,
  Action: CTAActionContainer,
});
